import { useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import mutation from './mutation.graphql.js'

export function useOnDelete(props) {
  let email = useDataValue({
    viewPath: props.viewPath,
    context: 'email',
  })

  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)

  let setFlowTo = useSetFlowTo(props.viewPath)
  return async function onClick() {
    let mutationResponse = await executeMutation({
      association_id: email.id,
    })
    if (mutationResponse.error) {
      notify(notifyError('Something went wrong. Please, try again.'))
      return
    }
    notify(notifySuccess('Email deleted!'))
    setFlowTo(normalizePath(props.viewPath, '../../../No'))
  }
}
